import React, { useState, ChangeEvent } from 'react';

function URLConverter() {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState('');
    const [mode, setMode] = useState<'encode' | 'decode'>('encode');

    const handleConvert = () => {
        try {
            if (mode === 'encode') {
                setOutput(encodeURIComponent(input));
            } else {
                setOutput(decodeURIComponent(input));
            }
        } catch (error) {
            setOutput('Error: Invalid input');
        }
    };

    const handleClear = () => {
        setInput('');
        setOutput('');
    };

    // Handle Enter key press
    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleConvert();
        }
    };

    return (
        <div className="tool">
            <h2>URL Encoder/Decoder</h2>
            <div className="content">
                <div className="url-converter">
                    <div className="url-converter__input-section">
                        <div className="url-converter__input-type">
                            <div className="url-converter__type-selector">
                                <button
                                    className={`url-converter__type-button ${mode === 'encode' ? 'active' : ''}`}
                                    onClick={() => setMode('encode')}
                                >
                                    Encode URL
                                </button>
                                <button
                                    className={`url-converter__type-button ${mode === 'decode' ? 'active' : ''}`}
                                    onClick={() => setMode('decode')}
                                >
                                    Decode URL
                                </button>
                            </div>
                        </div>

                        <div className="url-converter__input-container">
                            <input
                                type="text"
                                value={input}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setInput(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder={mode === 'encode' ? 'Enter URL to encode...' : 'Enter encoded URL to decode...'}
                                className="url-converter__input"
                            />
                            <button 
                                onClick={handleClear}
                                className="url-converter__clear-button"
                            >
                                Clear
                            </button>
                        </div>

                        <button 
                            onClick={handleConvert}
                            className="url-converter__convert-button"
                        >
                            Convert
                        </button>
                    </div>

                    <div className="url-converter__results">
                        {output && (
                            <div>
                                <p>Result: {output}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default URLConverter; 